document.addEventListener('DOMContentLoaded', () => {
    function customSelect(container) {
        let head = container.querySelector('.js-head .js-select'),
            input = container.querySelector('input'),
            inputSearch = container.querySelector('.js-input-search'),
            options = [...container.querySelectorAll('.js-option')]

        let open = () => container.classList.add('active'),
            close = () => container.classList.remove('active'),
            toggle = () => {
                container.classList.toggle('active')
                inputSearch.focus()
            },
            isOpened = () => container.classList.contains('active'),
            setValue = (value, label) => {
                head.innerHTML = label
                head.value = value.trim() // from @lunar616
                input.value = value
                input.dispatchEvent(new Event('change'))
                container.classList.add('checked')
            }

        container.addEventListener('click', toggle)
        options.forEach(option => {
            option.addEventListener('click', event => {
                let selectedOption = option.innerHTML;

                setValue(selectedOption, selectedOption)

                options.forEach(notActiveOption => notActiveOption.classList.remove('active'))
                option.classList.add('active')
            })
        })

        $(document).not(container).on('click', event => {
            isOpened() && !container.contains(event.target) &&  close()
        })
    }

    document.querySelectorAll('.js-custom-dropdown').forEach(container => customSelect(container))
})

//
// $(document).ready(function () {
//     $('.js-custom-dropdown').each((index, dropdown) => {
//         let $dropdown = $(dropdown),
//             $head = $dropdown.find('.js-head'),
//             $input = $dropdown.find('input'),
//             $options = $dropdown.find('.js-option');
//
//         $dropdown.on('click', () => $dropdown.toggleClass('active'))
//
//         $options.on('click', () => {
//             let selectedOption = $(this).text();
//
//             $head.children('.js-select').text(selectedOption);
//             $input.val(selectedOption);
//             $dropdown.addClass('checked');
//
//             $dropdown.addClass('active');
//             $options.not($dropdown).removeClass('active');
//         })
//     })
//
//     const dropdown = $('.js-custom-dropdown');
//
//     dropdown.on('click', function (event) {
//         event.preventDefault();
//
//         const $this = $(this),
//             currentHead = $this.find('.js-head'),
//             currentInput = $this.find('input'),
//             currentOptions = $this.find('.js-option');
//
//         $this.toggleClass('active');
//
//         currentOptions.on('click', function () {
//             const selectedOption = $this.text();
//
//             currentHead.children('.js-select').text(selectedOption);
//             currentInput.val(selectedOption);
//             $this.addClass('checked');
//
//             $this.addClass('active');
//             currentOptions.not($this).removeClass('active');
//         });
//     });
//
//     $(document).on('click', function (event) {
//         dropdown.removeClass('active');
//     });
// });
